import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbInputSearch } from '@celebration/design-system/dist/lib/input-search';

export default createComponent({
    react: React,
    elementClass: ClbInputSearch,
    tagName: ClbInputSearch.tagName,
    events: ClbInputSearch.events,
});
